import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { BillPaymentModalProps } from './BillPaymentConfirmation.modal.web';

export enum BillPaymentConfirmationStackRoutes {
  BillPaymentConfirm = 'BillPaymentConfirm'
}

export type BillPaymentConfirmationStackParamList = {
  [BillPaymentConfirmationStackRoutes.BillPaymentConfirm]: BillPaymentModalProps;
};

export type BillPaymentConfirmationStackScreenProps<Screen extends keyof BillPaymentConfirmationStackParamList> = NativeStackScreenProps<
  BillPaymentConfirmationStackParamList,
  Screen
>;
